import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, LogIn, AlertCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(API_ENDPOINTS.adminLogin, { username, password });
      sessionStorage.setItem('adminToken', res.data.token);
      sessionStorage.setItem('adminUser', username);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.detail || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-navy to-[#0A2647] flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-none shadow-2xl" data-testid="admin-login-card">
        <CardContent className="p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-navy rounded-full flex items-center justify-center mx-auto mb-4">
              <Lock className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-serif font-bold text-gray-900">Administration HPD</h1>
            <p className="text-gray-500 mt-1 font-sans text-sm">Connectez-vous pour gerer le site</p>
          </div>

          {error && (
            <div className="flex items-center gap-2 p-3 mb-6 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm font-sans" data-testid="login-error">
              <AlertCircle className="w-4 h-4 flex-shrink-0" />
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="username" className="font-sans">Nom d'utilisateur</Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <Input id="username" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="admin" className="pl-10 h-12" required data-testid="admin-username" />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="font-sans">Mot de passe</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe" className="pl-10 h-12" required data-testid="admin-password" />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full h-12 bg-navy hover:bg-navy/90 text-white text-base font-sans" data-testid="admin-login-btn">
              {loading ? 'Connexion...' : (<><LogIn className="w-4 h-4 mr-2" />Se Connecter</>)}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
